import App from './index';
import UpdateEdit from './components/update/index';

export default {
  path: '/home/app',
  component: App,
  children:[
    {path: '/home/app/update',component: UpdateEdit}
  ]
};
